import type {
  ThemePagesQueryResponse,
  ThemePagesQueryVariables,
} from '~/api/graphql/queries/themePages.generated';
import type { UseInfiniteQueryOptions } from '@tanstack/react-query';

import { ThemePagesDocument } from '~/api/graphql/queries/themePages.generated';
import { useInfiniteQuery } from '@tanstack/react-query';
import { appFetcher } from '~/api/utils';

const QUERY_KEY = 'theme-page-management-infinity';

export const useInfinityThemePageManagement = (
  variables: ThemePagesQueryVariables,
  options?: Omit<
    UseInfiniteQueryOptions<ThemePagesQueryResponse, ThemePagesQueryVariables>,
    'queryKey' | 'queryFn'
  >,
) => {
  return useInfiniteQuery(
    variables === undefined ? [QUERY_KEY] : [QUERY_KEY, variables],
    (args) => {
      return appFetcher<ThemePagesQueryResponse, ThemePagesQueryVariables>(ThemePagesDocument, {
        ...variables,
        after: args.pageParam,
      })();
    },
    options,
  );
};
